<div class="row-tags">
  <rms-domain-badges *ngIf="domains?.length" [domains]="domains" justifyContent="flex-start" gap="2px"></rms-domain-badges>
  <div *ngIf="positionTypeBadge" class="row-tags-position">{{ positionTypeBadge }}</div>
  <ng-content></ng-content>
</div>
